<template>
  <div class="box">
    <img :src="current.icon" class="icons" />
    <div class="num">
      {{ this.numHandle(this.calcHandle()) }}
    </div>
  </div>
</template>
<script>
export default {
  props: {
    recommendCount: {
      type: Number,
      default: 0,
    },
    unRecommendCount: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      list: [
        {
          value: [0],
          icon: require('../assets/images/recommend/zero.png'),
        },
        {
          value: [0, 1],
          icon: require('../assets/images/recommend/half.png'),
        },
        {
          value: [1, 1.5],
          icon: require('../assets/images/recommend/one.png'),
        },
        {
          value: [1.5, 2],
          icon: require('../assets/images/recommend/one_half.png'),
        },
        {
          value: [2, 2.5],
          icon: require('../assets/images/recommend/two.png'),
        },
        {
          value: [2.5, 3],
          icon: require('../assets/images/recommend/two_half.png'),
        },
        {
          value: [3, 3.5],
          icon: require('../assets/images/recommend/three.png'),
        },
        {
          value: [3.5, 4],
          icon: require('../assets/images/recommend/three_half.png'),
        },
        {
          value: [4, 4.5],
          icon: require('../assets/images/recommend/four.png'),
        },
        {
          value: [4.5, 5],
          icon: require('../assets/images/recommend/four_half.png'),
        },
        {
          value: [5],
          icon: require('../assets/images/recommend/five.png'),
        },
      ],
      current: '',
    }
  },

  mounted() {
    this.renderRecommend(this.calcHandle())
  },
  methods: {
    calcHandle() {
      const num = Number(this.recommendCount) + Number(this.unRecommendCount)
      return Math.floor((Number(this.recommendCount) / num) * 5 * 10) / 10 || 0
    },
    renderRecommend(num) {
      let current
      if (num === 0) {
        current = this.list[0]
      } else if (num === 5) {
        current = this.list[this.list.length - 1]
      } else {
        current = this.list.find((item) => {
          if (num >= item.value[0] && num < item.value[1]) {
            return item
          }
        })
      }
      this.current = current
    },
    numHandle(value) {
      if (!value) return '暂无推荐'
      return `${value}`.indexOf('.') > -1 ? value : `${value}.0`
    },
  },
}
</script>

<style lang="less" scoped>
.box {
  display: flex;
  align-items: center;
}
.icons {
  width: 78px;
  height: 14px;
}
.num {
  margin-left: 10px;
  font-size: 13px;
  color: #333;
}
</style>
